import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TariffListUpdatedAtCell } from './tariff-list-updated-at.cell';
import { TariffListUpdatedAtHeader } from './tariff-list-updated-at.header';

export const TariffListUpdatedAtColumn: IdentifiedColumnDef<
  TariffModel,
  TariffModel['updatedAt']
> = {
  enableSorting: true,
  header: TariffListUpdatedAtHeader,
  cell: TariffListUpdatedAtCell,
};
